import { useMutation } from '@apollo/client';
import { Save } from '@mui/icons-material';
import { Box, Grid } from '@mui/material';
import { Field, Formik } from 'formik';
import { useEffect, useState } from 'react';
import * as Yup from 'yup';
import InputV2Formik from '../components/input-v2/mui-input-v2-formik';
import { ButtonComponent, ButtonOutlineComponent } from '../components/mui-button';
import UploadableFotoPerfil from '../components/mui-uploadable-foto-perfil';
import { toastNotification } from '../components/toastify';
import { ATUALIZAR_COMERCIAL } from '../graphql/mutation';
import { uploadAmazonS3 } from '../services/UploadService';
import { getImageAuth } from '../utils/get-image';
import string from '../utils/string';

export const AtualizaPerfilContainer = ({comercial = {}, onClickRedefinirSenha}) => {
  const {
    fotoPerfil,
    celular,
    nomeRazao,
    nomeContato,
    cpfCnpj,
    email
  } = comercial;

  const [avatar, setAvatar] = useState(getImageAuth(fotoPerfil));
  const [uploadImage, setUploadImage] = useState(undefined);
  const [previewImage, setPreviewImage] = useState(undefined);
  const [loading, setLoading] = useState(false);

  const [atualizarComercial, {loadingQuery}] = useMutation(ATUALIZAR_COMERCIAL);

  useEffect(() => {
    setAvatar(fotoPerfil);
    // eslint-disable-next-line
  }, [comercial]);

  const handleChangeUploadImage = (e) => {
    const file = Array.from(e.target.files)[0];
    setUploadImage(file);
    handlePreviewImage(file);
  }

  const handlePreviewImage = (file) => {
    const reader = new FileReader();

    reader.addEventListener(
      'load',
      function () {
        setPreviewImage(reader.result);
      },
      false,
    );

    if (file) {
      reader.readAsDataURL(file);
    }
  }

  const handleSubmitClick = async (values) => {
    if (loading || loadingQuery) return;
    setLoading(true);

    let uploadData = null;
    try {
      if (uploadImage) {
        uploadData = await uploadAmazonS3(uploadImage);
      }
    } catch (error) {
      console.error(error);
    }

    atualizarComercial({
      variables: {
        comercial: {
          ...values,
          cpfCnpj: string.removeSpecialChars(values.cpfCnpj),
          celular: string.removeSpecialChars(values.celular),
          fotoPerfil: uploadData?.id || comercial.fotoPerfil,
        },
      },
    })
      .then(() => toastNotification({message: 'Dados atualizados com sucesso!', type: 'success'}))
      .catch((error) => toastNotification({message: error.message, type: 'error'}))
      .finally(() => setLoading(false));
  }

  return (
    <Grid container className='styled-scroll-transparent' sx={styles.container}>
      <Formik
        validationSchema={UserScheme}
        initialValues={{cpfCnpj, email, celular, nomeRazao, nomeContato}}
      >
        {({values}) => (
          <Box component="form" style={{height: '100%'}}>
            <Grid container spacing={2} padding={2} sx={styles.formContainer}>
              <Grid container item xs={12} spacing={2} justifyContent={'center'}>
                <UploadableFotoPerfil
                  image={previewImage || avatar}
                  setImage={setAvatar}
                  handleChangeUploadImage={handleChangeUploadImage}
                  showEnviarLabel={false}
                  sx={styles.avatar}
                />
                <Grid item xs={12}>
                  <Field
                    component={InputV2Formik}
                    name="cpfCnpj"
                    label="CPF/CNPJ"
                    mask="cpfCnpj"
                  />
                </Grid>
                <Grid item xs={12}>
                  <Field
                    component={InputV2Formik}
                    name="nomeRazao"
                    label="Razão social"
                  />
                </Grid>
                <Grid item xs={12}>
                  <Field
                    component={InputV2Formik}
                    name="nomeContato"
                    label="Nome"
                  />
                </Grid>
                <Grid item xs={12}>
                  <Field
                    component={InputV2Formik}
                    name="email"
                    label="E-mail"
                  />
                </Grid>
                <Grid item xs={12}>
                  <Field
                    component={InputV2Formik}
                    name="celular"
                    label="Celular"
                    mask="phone"
                  />
                </Grid>
              </Grid>
              <Grid container item xs={12} spacing={2}>
                <Grid item xs={12}>
                  <ButtonComponent
                    type="button"
                    disabled={loading}
                    value={'Atualizar dados'}
                    loading={loading}
                    icon={<Save />}
                    onClick={() => handleSubmitClick(values)}
                  />
                </Grid>
                <Grid item xs={12}>
                  <ButtonOutlineComponent
                    value={`Redefinir Senha`}
                    type="button"
                    disabled={loading}
                    onClick={onClickRedefinirSenha}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Box>
        )}
      </Formik>
    </Grid>
  );
};

const UserScheme = Yup.object().shape({
  emailUsuario: Yup.string()
    .email('Email inválido')
    .required('Campo não informado'),
  telefone: Yup.string().required('Campo não informado'),
  cnpj: Yup.string().required('Campo não informado'),
  nomeRazao: Yup.string().required('Campo não informado'),
});

const styles = {
  container: {
    justifyContent: 'center',
    alignContent: 'flex-start',
    height: theme => `calc(100vh - ${theme.toolbarHeight})`,
    paddingTop: '16px',
    overflow: 'auto',
  },
  formContainer: {
    alignContent: 'space-between',
    height: '100%'
  },
  avatar: {
    width: '90px',
    height: '90px',
    marginTop: theme => theme.space[2],
    marginBottom: '10px',
    boxShadow: '0px 0px 10px rgb(0 0 0 / 20%)',
    borderRadius: '50%',
    overflow: 'hidden',
    fotoContainer: {
      width: '100%',
      height: '100%',
      border: 'none',
    }
  }
};